import {
  PlayButton,
  useMediaState,
  type PlayButtonProps,
} from "@vidstack/react";
import { PauseIcon, PlayIcon } from "lucide-react";
import { forwardRef } from "react";
import { cn } from "~/lib/utils";

const DefaultPlayButton = forwardRef<HTMLButtonElement, PlayButtonProps>(
  ({ className, ...props }, ref) => {
    const isPaused = useMediaState("paused");
    return (
      <PlayButton
        ref={ref}
        className={cn(
          "flex items-center justify-center w-14 h-14 bg-primary rounded-full",
          className
        )}
        {...props}
      >
        {isPaused ? (
          <PlayIcon
            size={28}
            color="black"
            className="data-can-play:bg-green-500"
          />
        ) : (
          <PauseIcon size={28} color="black" />
        )}
      </PlayButton>
    );
  }
);
DefaultPlayButton.displayName = "DefaultPlayButton";
export default DefaultPlayButton;
